import { defineMessages } from "react-intl";

const PREFIX = "Subscriptions.SubscriptionsToolbar";
export const messages = defineMessages({
  titlePage: {
    id: `${PREFIX}.titlePage`,
    defaultMessage: "Subscriptions",
  },
});
